import type { AppView } from "../../app/shell-view.ts";

export interface ShellNavigationCapabilities {
  selectView(view: AppView): void | Promise<void>;
  selectSavedView(id: string): void | Promise<void>;
  selectRoot(id: string): void | Promise<void>;
  selectCategory(id: string, rootId: string): void | Promise<void>;
  search(value: string): void | Promise<void>;
  rememberSearch(): void | Promise<void>;
  setInactiveDays(value: string): void | Promise<void>;
}

export function bindShellNavigation(container: ParentNode, capabilities: ShellNavigationCapabilities): void {
  container.querySelectorAll<HTMLElement>("[data-view]").forEach(button => {
    button.addEventListener("click", () => void capabilities.selectView(button.dataset.view as AppView));
  });
  container.querySelectorAll<HTMLElement>("[data-saved-view]").forEach(button => {
    button.addEventListener("click", () => {
      if (button.dataset.savedView) void capabilities.selectSavedView(button.dataset.savedView);
    });
  });
  container.querySelectorAll<HTMLElement>("[data-root]").forEach(button => {
    button.addEventListener("click", () => {
      if (button.dataset.root) void capabilities.selectRoot(button.dataset.root);
    });
  });
  container.querySelectorAll<HTMLElement>("[data-category]").forEach(button => {
    button.addEventListener("click", () => {
      if (button.dataset.category && button.dataset.parentRoot) void capabilities.selectCategory(button.dataset.category, button.dataset.parentRoot);
    });
  });
  container.querySelector<HTMLInputElement>("#search")?.addEventListener("input", event => {
    void capabilities.search((event.currentTarget as HTMLInputElement).value);
  });
  container.querySelector<HTMLInputElement>("#search")?.addEventListener("change", () => void capabilities.rememberSearch());
  container.querySelector<HTMLSelectElement>("[data-board-inactive]")?.addEventListener("change", async event => {
    const select = event.currentTarget as HTMLSelectElement;
    await capabilities.setInactiveDays(select.value);
    select.ownerDocument.querySelector<HTMLElement>("[data-task-filter-trigger]")?.focus({ preventScroll: true });
  });
  container.querySelector<HTMLElement>("[data-clear-board-inactive]")?.addEventListener("click", async event => {
    const button = event.currentTarget as HTMLElement;
    await capabilities.setInactiveDays("0");
    button.ownerDocument.querySelector<HTMLElement>("[data-task-filter-trigger]")?.focus({ preventScroll: true });
  });
}
